// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/elevation-pushpin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/elevation-position.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-hidden {
  visibility: hidden;
}

.legend {
  cursor: pointer;
}

.leaflet-container {
  z-index: 0;
  /* prevent overlapping the .elevation-detached chart */
}

.elevation-control .background {
  background-color: var(--ele-bg, rgba(70, 130, 180, 0.2));
  border-radius: 5px;
  overflow: visible;
  display: block;
  touch-action: none;
  user-select: none;
  max-width: 100%;
}

.elevation-control .grid,
.elevation-control .area > foreignObject,
.elevation-control .axis,
.elevation-control .tooltip,
.height-focus.line {
  pointer-events: none;
}

.elevation-control .axis line,
.elevation-control .axis path {
  stroke: var(--ele-axis, #2D1130);
  stroke-width: 1;
  fill: none;
}

.elevation-control .grid .tick line {
  stroke: var(--ele-grid, #EEE);
  stroke-width: 1px;
  shape-rendering: crispEdges;
}

.elevation-control .grid path {
  stroke-width: 0;
}

.elevation-control .axis text,
.elevation-control .legend text,
.elevation-control .point text {
  fill: #000;
  font-weight: 700;
  paint-order: stroke fill;
  stroke: #fff;
  stroke-width: 2px
}

.elevation-control .y.axis text {
  text-anchor: end;
}

.elevation-control .area {
  fill: var(--ele-area, #4682B4);
  stroke: var(--ele-stroke, #000);
  stroke-width: 1.2;
  paint-order: stroke fill;
}

.elevation-control .horizontal-drag-line {
  cursor: row-resize;
  stroke: transparent;
  stroke-dasharray: 5;
  stroke-width: 1.1;
}

.elevation-control .active .horizontal-drag-line {
  stroke: #000;
}

.elevation-control .horizontal-drag-label {
  fill: #000;
  font-weight: 700;
  paint-order: stroke;
  stroke: #FFF;
  stroke-width: 2px;
}

.elevation-control .ruler {
  color: #000;
  cursor: row-resize;
}

.elevation-control .mouse-focus-line {
  stroke: #000;
  stroke-width: 1;
}

.elevation-control .mouse-focus-label-rect {
  fill: #000;
  fill-opacity: 0.75;
  stroke-width: 1;
  stroke: #444;
}

.elevation-control .mouse-focus-label-text {
  fill: #FFF;
  font-size: 10px;
}

.elevation-control .brush .overlay {
  cursor: unset;
}

.elevation-control .brush .selection {
  fill: var(--ele-brush, rgba(23, 74, 117, 0.4));
  stroke: none;
  fill-opacity: unset;
}

.elevation-summary {
  font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif;
  font-size: 12px;
  margin: var(--ele-sum-margin, 0 auto);
  text-shadow: var(--ele-sum-shadow, 1px 0 0 #FFF, -1px 0 0 #FFF, 0 1px 0 #FFF, 0 -1px 0 #FFF, 1px 1px #FFF, -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF);
}

.elevation-summary>span:not(:last-child):after {
  content: var(--ele-sum-sep, '');
}

.multiline-summary>span {
  display: block;
}

.multiline-summary .download {
  float: right;
  margin-top: -3em;
  margin-right: 2em;
  font-weight: bold;
  font-size: 1.2em;
}

.elevation-summary .summaryvalue {
  font-weight: bold;
}

.elevation-toggle-icon {
  background-color: #fff;
  right: 5px;
  top: 5px;
  height: var(--ele-toggle-size, 36px);
  width: var(--ele-toggle-size, 36px);
  cursor: pointer;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  display: inline-block;
  position: var(--ele-toggle-pos, relative);
}

.elevation-toggle-icon:before {
  content: '\\2716';
  display: var(--ele-close-btn, none);
  color: #000;
  width: 100%;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 15px;
}

.leaflet-elevation-pane .height-focus,
.leaflet-overlay-pane .height-focus {
  stroke: #000;
  fill: var(--ele-circle, var(--ele-area, #FFF));
}

.leaflet-elevation-pane .height-focus.line,
.leaflet-overlay-pane .height-focus.line {
  stroke-width: 2;
}

.leaflet-elevation-pane .height-focus-label,
.leaflet-overlay-pane .height-focus-label {
  font-size: 12px;
  font-weight: 600;
  fill: #000;
  paint-order: stroke;
  stroke: #FFF;
  stroke-width: 2px;
}

.elevation-waypoint-icon:before,
.elevation-position-icon:before {
  content: "";
  width: 100%;
  height: 100%;
  display: inline-block;
  background: var(--ele-marker) no-repeat center center / contain;
}

.elevation-polyline {
  stroke: var(--ele-poly, var(--ele-area, #000));
  filter: drop-shadow(1px 1px 0 #FFF) drop-shadow(-1px -1px 0 #FFF) drop-shadow(1px -1px 0 #FFF) drop-shadow(-1px 1px 0 #FFF);
}

/* CHART STATES /////////////////////////////////////////////////// */

.elevation-detached {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  height: auto;
  width: 100%;
  position: relative;
  z-index: 0;
}

.elevation-detached .area {
  fill-opacity: var(--ele-alpha, 0.8);
}

.elevation-detached.elevation-collapsed .elevation-summary {
  display: block;
}

.elevation-detached.elevation-collapsed .elevation-toggle-icon {
  top: 5px;
  right: 9px;
  bottom: 5px;
  margin: auto;
}

.elevation-control.elevation-collapsed > * {
  display: none;
}

.elevation-control.elevation-collapsed > .elevation-toggle-icon {
  display: inline-block;
}

.elevation-detached {
  --ele-sum-margin: 12px 35px;
  --ele-sum-shadow: none;
  --ele-toggle-pos: absolute;
}

.elevation-expanded {
  --ele-close-btn: inline-block;
  --ele-toggle-bg: none;
  --ele-toggle-pos: absolute;
  --ele-toggle-size: 20px;
}

.inline-summary {
  --ele-sum-sep: "\\0020\\2014\\0020";
}

.elevation-waypoint-icon {
  --ele-marker: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.elevation-position-icon {
  --ele-marker: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* LIME THEME ///////////////////////////////////////////////////// */

.lime-theme {
  --ele-bg: rgba(156, 194, 34, 0.2);
  --ele-axis: #566B13;
  --ele-area: #9CC222;
  --ele-grid: #CCC;
  --ele-brush: rgba(99, 126, 11, 0.4);
  --ele-poly: #566B13;
  --ele-line: #70ab00;
}

/* STEELBLUE THEME //////////////////////////////////////////////// */

.steelblue-theme {
  --ele-axis: #0D1821;
  --ele-area: #4682B4;
  --ele-brush: rgba(23, 74, 117, 0.4);
  --ele-line: #174A75;
}

/* PURPLE THEME /////////////////////////////////////////////////// */

.purple-theme {
  --ele-bg: rgba(115, 44, 123, 0.2);
  --ele-area: #732C7B;
  --ele-brush: rgba(74, 14, 80, 0.4);
  --ele-line: #732c7b;
}

/* YELLOW THEME /////////////////////////////////////////////////// */

.yellow-theme {
  --ele-area: #FF0;
}

/* RED THEME ////////////////////////////////////////////////////// */

.red-theme {
  --ele-area: #F00;
}

/* MAGENTA THEME ////////////////////////////////////////////////// */

.magenta-theme {
  --ele-bg: rgba(255, 255, 255, 0.47);
  --ele-area: #FF005E;
}

/* LIGHTBLUE THEME //////////////////////////////////////////////// */

.lightblue-theme {
  --ele-area: #3366CC;
  --ele-alpha: 0.45;
  --ele-stroke: #4682B4;
  --ele-circle: #fff;
  --ele-line: #000;
}

.elevation-detached.lightblue-theme .area {
  stroke: #3366CC;
}

/* leaflet-distance-markers */

.dist-marker {
  font-size: 0.5rem;
  border: 1px solid #777;
  border-radius: 10px;
  text-align: center;
  color: #000;
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@raruto/leaflet-elevation/dist/leaflet-elevation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0FAA0F;EAC1F,eAAe;EACf,qCAAqC;EACrC,8JAA8J;AAChK;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,8CAA8C;EAC9C,2HAA2H;AAC7H;;AAEA,qEAAqE;;AAErE;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qDAAkD;AACpD;;AAEA;EACE,qDAAmD;AACrD;;AAEA,qEAAqE;;AAErE;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qEAAqE;;AAErE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,qEAAqE;;AAErE;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,qEAAqE;;AAErE;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;;AAErE;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;;AAErE;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,qEAAqE;;AAErE;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".leaflet-hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.legend {\r\n  cursor: pointer;\r\n}\r\n\r\n.leaflet-container {\r\n  z-index: 0;\r\n  /* prevent overlapping the .elevation-detached chart */\r\n}\r\n\r\n.elevation-control .background {\r\n  background-color: var(--ele-bg, rgba(70, 130, 180, 0.2));\r\n  border-radius: 5px;\r\n  overflow: visible;\r\n  display: block;\r\n  touch-action: none;\r\n  user-select: none;\r\n  max-width: 100%;\r\n}\r\n\r\n.elevation-control .grid,\r\n.elevation-control .area > foreignObject,\r\n.elevation-control .axis,\r\n.elevation-control .tooltip,\r\n.height-focus.line {\r\n  pointer-events: none;\r\n}\r\n\r\n.elevation-control .axis line,\r\n.elevation-control .axis path {\r\n  stroke: var(--ele-axis, #2D1130);\r\n  stroke-width: 1;\r\n  fill: none;\r\n}\r\n\r\n.elevation-control .grid .tick line {\r\n  stroke: var(--ele-grid, #EEE);\r\n  stroke-width: 1px;\r\n  shape-rendering: crispEdges;\r\n}\r\n\r\n.elevation-control .grid path {\r\n  stroke-width: 0;\r\n}\r\n\r\n.elevation-control .axis text,\r\n.elevation-control .legend text,\r\n.elevation-control .point text {\r\n  fill: #000;\r\n  font-weight: 700;\r\n  paint-order: stroke fill;\r\n  stroke: #fff;\r\n  stroke-width: 2px\r\n}\r\n\r\n.elevation-control .y.axis text {\r\n  text-anchor: end;\r\n}\r\n\r\n.elevation-control .area {\r\n  fill: var(--ele-area, #4682B4);\r\n  stroke: var(--ele-stroke, #000);\r\n  stroke-width: 1.2;\r\n  paint-order: stroke fill;\r\n}\r\n\r\n.elevation-control .horizontal-drag-line {\r\n  cursor: row-resize;\r\n  stroke: transparent;\r\n  stroke-dasharray: 5;\r\n  stroke-width: 1.1;\r\n}\r\n\r\n.elevation-control .active .horizontal-drag-line {\r\n  stroke: #000;\r\n}\r\n\r\n.elevation-control .horizontal-drag-label {\r\n  fill: #000;\r\n  font-weight: 700;\r\n  paint-order: stroke;\r\n  stroke: #FFF;\r\n  stroke-width: 2px;\r\n}\r\n\r\n.elevation-control .ruler {\r\n  color: #000;\r\n  cursor: row-resize;\r\n}\r\n\r\n.elevation-control .mouse-focus-line {\r\n  stroke: #000;\r\n  stroke-width: 1;\r\n}\r\n\r\n.elevation-control .mouse-focus-label-rect {\r\n  fill: #000;\r\n  fill-opacity: 0.75;\r\n  stroke-width: 1;\r\n  stroke: #444;\r\n}\r\n\r\n.elevation-control .mouse-focus-label-text {\r\n  fill: #FFF;\r\n  font-size: 10px;\r\n}\r\n\r\n.elevation-control .brush .overlay {\r\n  cursor: unset;\r\n}\r\n\r\n.elevation-control .brush .selection {\r\n  fill: var(--ele-brush, rgba(23, 74, 117, 0.4));\r\n  stroke: none;\r\n  fill-opacity: unset;\r\n}\r\n\r\n.elevation-summary {\r\n  font-family: \"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif;\r\n  font-size: 12px;\r\n  margin: var(--ele-sum-margin, 0 auto);\r\n  text-shadow: var(--ele-sum-shadow, 1px 0 0 #FFF, -1px 0 0 #FFF, 0 1px 0 #FFF, 0 -1px 0 #FFF, 1px 1px #FFF, -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF);\r\n}\r\n\r\n.elevation-summary>span:not(:last-child):after {\r\n  content: var(--ele-sum-sep, '');\r\n}\r\n\r\n.multiline-summary>span {\r\n  display: block;\r\n}\r\n\r\n.multiline-summary .download {\r\n  float: right;\r\n  margin-top: -3em;\r\n  margin-right: 2em;\r\n  font-weight: bold;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.elevation-summary .summaryvalue {\r\n  font-weight: bold;\r\n}\r\n\r\n.elevation-toggle-icon {\r\n  background-color: #fff;\r\n  right: 5px;\r\n  top: 5px;\r\n  height: var(--ele-toggle-size, 36px);\r\n  width: var(--ele-toggle-size, 36px);\r\n  cursor: pointer;\r\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n  position: var(--ele-toggle-pos, relative);\r\n}\r\n\r\n.elevation-toggle-icon:before {\r\n  content: '\\2716';\r\n  display: var(--ele-close-btn, none);\r\n  color: #000;\r\n  width: 100%;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  font-size: 15px;\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus,\r\n.leaflet-overlay-pane .height-focus {\r\n  stroke: #000;\r\n  fill: var(--ele-circle, var(--ele-area, #FFF));\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus.line,\r\n.leaflet-overlay-pane .height-focus.line {\r\n  stroke-width: 2;\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus-label,\r\n.leaflet-overlay-pane .height-focus-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  fill: #000;\r\n  paint-order: stroke;\r\n  stroke: #FFF;\r\n  stroke-width: 2px;\r\n}\r\n\r\n.elevation-waypoint-icon:before,\r\n.elevation-position-icon:before {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  display: inline-block;\r\n  background: var(--ele-marker) no-repeat center center / contain;\r\n}\r\n\r\n.elevation-polyline {\r\n  stroke: var(--ele-poly, var(--ele-area, #000));\r\n  filter: drop-shadow(1px 1px 0 #FFF) drop-shadow(-1px -1px 0 #FFF) drop-shadow(1px -1px 0 #FFF) drop-shadow(-1px 1px 0 #FFF);\r\n}\r\n\r\n/* CHART STATES /////////////////////////////////////////////////// */\r\n\r\n.elevation-detached {\r\n  font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n  height: auto;\r\n  width: 100%;\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n\r\n.elevation-detached .area {\r\n  fill-opacity: var(--ele-alpha, 0.8);\r\n}\r\n\r\n.elevation-detached.elevation-collapsed .elevation-summary {\r\n  display: block;\r\n}\r\n\r\n.elevation-detached.elevation-collapsed .elevation-toggle-icon {\r\n  top: 5px;\r\n  right: 9px;\r\n  bottom: 5px;\r\n  margin: auto;\r\n}\r\n\r\n.elevation-control.elevation-collapsed > * {\r\n  display: none;\r\n}\r\n\r\n.elevation-control.elevation-collapsed > .elevation-toggle-icon {\r\n  display: inline-block;\r\n}\r\n\r\n.elevation-detached {\r\n  --ele-sum-margin: 12px 35px;\r\n  --ele-sum-shadow: none;\r\n  --ele-toggle-pos: absolute;\r\n}\r\n\r\n.elevation-expanded {\r\n  --ele-close-btn: inline-block;\r\n  --ele-toggle-bg: none;\r\n  --ele-toggle-pos: absolute;\r\n  --ele-toggle-size: 20px;\r\n}\r\n\r\n.inline-summary {\r\n  --ele-sum-sep: \"\\0020\\2014\\0020\";\r\n}\r\n\r\n.elevation-waypoint-icon {\r\n  --ele-marker: url(../images/elevation-pushpin.svg);\r\n}\r\n\r\n.elevation-position-icon {\r\n  --ele-marker: url(../images/elevation-position.svg);\r\n}\r\n\r\n/* LIME THEME ///////////////////////////////////////////////////// */\r\n\r\n.lime-theme {\r\n  --ele-bg: rgba(156, 194, 34, 0.2);\r\n  --ele-axis: #566B13;\r\n  --ele-area: #9CC222;\r\n  --ele-grid: #CCC;\r\n  --ele-brush: rgba(99, 126, 11, 0.4);\r\n  --ele-poly: #566B13;\r\n  --ele-line: #70ab00;\r\n}\r\n\r\n/* STEELBLUE THEME //////////////////////////////////////////////// */\r\n\r\n.steelblue-theme {\r\n  --ele-axis: #0D1821;\r\n  --ele-area: #4682B4;\r\n  --ele-brush: rgba(23, 74, 117, 0.4);\r\n  --ele-line: #174A75;\r\n}\r\n\r\n/* PURPLE THEME /////////////////////////////////////////////////// */\r\n\r\n.purple-theme {\r\n  --ele-bg: rgba(115, 44, 123, 0.2);\r\n  --ele-area: #732C7B;\r\n  --ele-brush: rgba(74, 14, 80, 0.4);\r\n  --ele-line: #732c7b;\r\n}\r\n\r\n/* YELLOW THEME /////////////////////////////////////////////////// */\r\n\r\n.yellow-theme {\r\n  --ele-area: #FF0;\r\n}\r\n\r\n/* RED THEME ////////////////////////////////////////////////////// */\r\n\r\n.red-theme {\r\n  --ele-area: #F00;\r\n}\r\n\r\n/* MAGENTA THEME ////////////////////////////////////////////////// */\r\n\r\n.magenta-theme {\r\n  --ele-bg: rgba(255, 255, 255, 0.47);\r\n  --ele-area: #FF005E;\r\n}\r\n\r\n/* LIGHTBLUE THEME //////////////////////////////////////////////// */\r\n\r\n.lightblue-theme {\r\n  --ele-area: #3366CC;\r\n  --ele-alpha: 0.45;\r\n  --ele-stroke: #4682B4;\r\n  --ele-circle: #fff;\r\n  --ele-line: #000;\r\n}\r\n\r\n.elevation-detached.lightblue-theme .area {\r\n  stroke: #3366CC;\r\n}\r\n\r\n/* leaflet-distance-markers */\r\n\r\n.dist-marker {\r\n  font-size: 0.5rem;\r\n  border: 1px solid #777;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  color: #000;\r\n  background: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
